/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelemailheader4Inputs */

const en_aiflowchannelemailheader4 = /** @type {(inputs: Aiflowchannelemailheader4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email header`)
};

const de_aiflowchannelemailheader4 = /** @type {(inputs: Aiflowchannelemailheader4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail Kopf`)
};

/**
* | output |
* | --- |
* | "Email header" |
*
* @param {Aiflowchannelemailheader4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelemailheader4 = /** @type {((inputs?: Aiflowchannelemailheader4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelemailheader4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelemailheader4(inputs)
	return de_aiflowchannelemailheader4(inputs)
});
export { aiflowchannelemailheader4 as "aiFlowChannelEmailHeader" }